import styles from './Merchant.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { isEntry } from 'src/utils/EntryUtil';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { Text } from '../../Contentful/Text';

interface MerchantProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<Subject>;
}

export const Merchant: React.FC<MerchantProps> = ({ entry, className, ...props }) => {
  if (!isEntry(entry)) return null;

  const { image } = entry.fields;

  return (
    <div className={cx(className, styles.merchant)} {...props}>
      {image && (
        <div className={styles.logoWrap}>
          <ContentfulImage asset={image} className={styles.logo} />
        </div>
      )}
      <div className={styles.names}>
        <Text entry={entry} field="title" className={styles.merchantName} />
        <Text entry={entry} field="blurb" />
      </div>
    </div>
  );
};
